module.exports = __webpack_public_path__ + "static/img/bonus_3.c30d71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lhzb/bonus_3.png
// module id = 7nki
// module chunks = 0